module.exports = __webpack_public_path__ + "sw-back.jpg?8454fc32ea9654c67872b4a479157a62";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sad windows/sw-back.jpg
// module id = 30
// module chunks = 0